export enum ProjectTabName {
  Header = 'Header',
  Parameters = 'Parameters',
  Resources = 'Resources',
  AssetMapping = 'Asset Allocation',
  Team = 'Team',
  Schedule = 'Schedule',
  Estimates = 'Estimates',
  Accounting = 'Accounting'
}